module.exports = __webpack_public_path__ + "static/media/university-grid-4.ca1503c8.jpg";